import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import LightboxModal from './LightboxModal'

interface CircularImageGalleryProps {
  images: string[]
  alt?: string
  size?: string
}

const CircularImageGallery = ({ images, alt = 'image', size = '64px' }: CircularImageGalleryProps) => {
  const [photoIndex, setPhotoIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)

  if (!images || images.length === 0) {
    return <Typography>-</Typography>
  }

  const firstImage = images[0]
  const remainingCount = images.length - 1

  const handleClick = () => {
    if (images.length > 0) {
      setPhotoIndex(0)
      setIsOpen(true)
    }
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <>
      <Box
        onClick={handleClick}
        sx={{
          position: 'relative',
          width: size,
          height: size,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: size,
            height: size,
            borderRadius: '50%',
            overflow: 'hidden',
            border: '2px solid',
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'grey.100',
          }}
        >
          <img
            src={firstImage}
            alt={alt}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>
        {remainingCount > 0 && (
          <Box
            sx={{
              position: 'absolute',
              top: '-4px',
              right: '-2px',
              minWidth: '20px',
              height: '20px',
              borderRadius: '50%',
              backgroundColor: 'primary.main',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.75rem',
              fontWeight: 'bold',
              border: '2px solid',
              borderColor: 'background.paper',
              padding: '0 4px',
              zIndex: 1,
            }}
          >
            +{remainingCount}
          </Box>
        )}
      </Box>
      <LightboxModal
        images={images}
        photoIndex={photoIndex}
        setPhotoIndex={setPhotoIndex}
        isOpen={isOpen}
        onClose={handleClose}
      />
    </>
  )
}

export default CircularImageGallery

